import { PropertyTypes } from 'src/types/__generated__/graphql';

interface FormatFloorPositionParams {
    floorPosition: string | number | undefined | null;
    propertyType?: string;
}

const formatFloorPosition = ({ floorPosition, propertyType }: FormatFloorPositionParams): number | undefined => {
    switch (propertyType) {
        case PropertyTypes.House:
        case PropertyTypes.Land:
            return undefined;
        default:
            if (!Number.isNaN(Number(floorPosition))) {
                return Number(floorPosition);
            } else {
                return propertyType === PropertyTypes.Apartment ? 0 : undefined;
            }
    }
};

export { formatFloorPosition };
